/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import config from '../config';
import ApiError from '../services/g17eco/ApiError';
import { OktaStorage } from '../services/OktaStorage';
import { ErrorResponse } from '../types/api';

const tokenStorage = OktaStorage;

let httpClient: AxiosInstance
export const getHttpClient = (): AxiosInstance => {

  if (!httpClient) {
    httpClient = axios.create({ baseURL: config.apiUrl });

    httpClient.interceptors.request.use((c) => {
      if (c.headers) {
        c.headers.Authorization = tokenStorage.getAuthHeaderValue();
      }
      return c;
    })

    const onResponse = function checkResponse(response: AxiosResponse) {
      if (response.config.responseType !== 'blob' && response.data.success !== true) {
        throw new ApiError(response.data.userMessage)
      }
      return response;
    };

    const onRejected = async (error: AxiosError<ErrorResponse>) => {
      const status = error.response?.status;
      if (error.response?.data) {
        const { message, userMessage } = error.response.data;

        if (status === 403) {
          // Assume 403 is user safe message as fallback
          throw new ApiError(userMessage ?? message, status)
        }

        throw new ApiError(userMessage, status)
      }

      throw error;
    };

    httpClient.interceptors.response.use(onResponse, onRejected);
  }

  return httpClient;
}
